import React, { Component } from 'react';
import { Table, Segment, Header, Button, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import ExternalStudentEditWrapper from '../ExternalStudentForms/ExternalStudentEditWrapper';
import { toast } from 'react-toastify';
import axios from 'axios';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

class ExternalStudentCompletionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            unlockLoading: false,
        };
        this.onCancel = this.onCancel.bind(this);
        this.mobilityCerificate = this.mobilityCerificate.bind(this);
    }

    onCancel = () => {
        this.setState({
            editingCompletionDetails: false,
        });
    };

    onEdit = (editedStudent) => {
        this.setState({
            student: editedStudent,
        });
        this.props.onEdit(editedStudent);
    };

    handleUnlockStudent = (studentId) => {
        this.setState({ unlockLoading: true });
        axios.put(`/external-student/unlock/${studentId}`)
            .then((res) => {
                const updatedStudent = {
                    ...this.state.student,
                    lockedAt: null
                };
                this.onEdit(updatedStudent);
                this.setState({ unlockLoading: false });
                toast(<FormattedMessage id="externalStudent.toast.unlockSuccess"/>);
            })
            .catch((err) => {
                this.setState({ unlockLoading: false });
                toast(<FormattedMessage id="externalStudent.toast.unlockError"/>);
            });
    };

    mobilityCerificate(id, language) {
        let issueDate = moment(new Date()).format();
        const params = {
            language: language,
            ids: [id],
            issueDate,
            withLogo: true
        };
        axios({
            method: 'post',
            url: '/graduation-documents/print-mobility-certificate',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            })
    }

    render() {
        const {
            editingCompletionDetails,
            student,
            unlockLoading
        } = this.state;

        const { isMainOU } = this.props;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const canEdit = isInternationalCooperationService || (isStudentService && isMainOU);
        const disableCertificateDownload = !student.graduationDate;
        const showCertificateDownloadButton = student.mobilityType._key !== "cycle";

        return (
            <Segment basic compact>
                {editingCompletionDetails ? <ExternalStudentEditWrapper
                        student={student}
                        completionDetails
                        onCancel={this.onCancel}
                        onEdit={this.onEdit}
                    /> :
                    <Segment.Group>
                        <Segment>
                            <Header as="h3">
                                <Header.Content style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    {/* LEFT SIDE BUTTONS */}
                                    {showCertificateDownloadButton ?
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {/* <FormattedMessage id="externalStudent.completionDetails"/> */}
                                        {/* <Popup
                                            content="Preuzmi certifikat"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    onClick={
                                                        () => {
                                                            this.mobilityCerificate(localStorage.getItem('externalStudentId'), "bs");
                                                        }
                                                    }
                                                    size="small"
                                                    style={FiltersOnStyle}
                                                    basic
                                                    color="blue"
                                                    disabled={disableCertificateDownload}
                                                >
                                                    Certifikat BHS
                                                </Button>}
                                        />
                                        <Popup
                                            content="Preuzmi certifikat"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    onClick={
                                                        () => {
                                                            this.mobilityCerificate(localStorage.getItem('externalStudentId'), "en");
                                                        }
                                                    }
                                                    size="small"
                                                    style={FiltersOnStyle}
                                                    basic
                                                    color="blue"
                                                    disabled={disableCertificateDownload}
                                                >
                                                    Certifikat EN
                                                </Button>}
                                        /> */}
                                    </div> : <div></div>
                                    }


                                    {canEdit &&
                                        (<Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button
                                                icon="pencil"
                                                circular
                                                floated="right"
                                                basic
                                                color="green"
                                                disabled={student.lockedAt}
                                                size={'mini'}
                                                onClick={() => {
                                                    this.setState({ editingCompletionDetails: true });
                                                }}
                                            />}/>)}
                                </Header.Content>
                            </Header>
                        </Segment>
                        <Segment>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.graduationDate"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.graduationDate ? moment(student.graduationDate)
                                            .format('D. M. YYYY.') : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.certificateNumber"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.certificateNumber}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.dropoutDate"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.dropoutDate ? moment(student.dropoutDate)
                                            .format('D. M. YYYY.') : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.lockedAt"/>
                                        </Table.Cell>
                                        <Table.Cell style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                                    <span>{student.lockedAt ? moment(student.lockedAt)
                                                        .format('D. M. YYYY.') : '-'}</span>
                                            {canEdit && student.lockedAt && (
                                                <Popup
                                                    content={<FormattedMessage
                                                        id="externalStudent.unlockStudent"/>}
                                                    trigger={
                                                        <Button
                                                            loading={unlockLoading}
                                                            basic
                                                            circular
                                                            color={'blue'}
                                                            icon="unlock"
                                                            size="mini"
                                                            onClick={() => this.handleUnlockStudent(student.id)}
                                                        />
                                                    }
                                                />
                                            )}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Segment.Group>}
            </Segment>
        );
    }
}

export default ExternalStudentCompletionDetails;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentProfile/ExternalStudentCompletionDetails.js